import React, {FC, useState, useCallback, useEffect, useRef, memo} from 'react';
import {useParams} from "react-router-dom";
import queryString from 'query-string';
import routes from '../../../config/routes';
import {useDispatch, useSelector} from 'react-redux';
import reducer from './reducer';
import saga from './saga';
import {encodeData} from '../../../utils/url';

// Import Styles
import styled from 'styled-components';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import "../../../assets/react-typeahead.scss";
import intl from '../../../intl';
import Expand from 'react-expand-animated';
import colors from '../../../config/colors';
import FormInput from '../../../components/Inputs/Input';
import InputImg from '../../../components/Inputs/InputImg';
import Button from '../../../components/ButtonsStyle/index';
import SelectReset from '../../../components/Inputs/SelectReset';

// Import Messages
import { FormattedMessage } from 'react-intl';
import HomeMessages from './messages';
import messages from './messages';
import generalMessages from '../../generalMessages';

import find from 'lodash/find';
// Models
import { CityProps } from '../../../models/city';
import { SelectOption } from '../../../models/general';

// Import Selects
import {optionsSeniority, optionsLanguages, optionsContract, optionsLevel} from '../../../config/selectOptions';
import {loadingSelector, optionsCompaniesSelector, optionsPositionsSelector, optionsPositionSelector, optionsCitySelector, optionsCompanySelector} from './selectors';

// Import Actions
import {getCompaniesAction, getPositionsAction, getCityBySlug, getPositionBySlug, getCompanyBySlug, clearCityAction, clearPositionAction, clearCompanyAction, clearAll} from './actions';

// Import Categories Filter
import { getCitiesAction, selectCategoriesFilter } from '../../App/actions';
import { makeSelectCategoriesIndustry, makeSelectCategoriesAreaOfWork, optionsCitiesSelector } from '../../App/selectors';

import history from '../../../utils/history'
import { converFromEngToSrb, converFromSrbToEng } from '../../../utils/seoConverter';
import CheckboxLg from '../../../components/Inputs/CheckboxLg';
import H3 from '../../../components/Headings/H3';
import { useInjectSagaAndReducer } from '../../../utils/helpers';
import { REDUX_SAGA_KEYS } from '../../../config/config';

interface IFilters {
  clearFilters?: boolean,
  closeModal?: () => void ;
  searchResults?: (value: any)=> void;
}

const Filters: FC<IFilters> = ({closeModal, searchResults, clearFilters}) => {

  useInjectSagaAndReducer(REDUX_SAGA_KEYS.filters, reducer, saga);

  const searchParams = history.location.search;
  const rawParams = queryString.parse(searchParams);

  const params = converFromSrbToEng ({
      pozicija : rawParams.pozicija ? rawParams.pozicija : null ,
      grad : rawParams.grad ? rawParams.grad : null ,
      poslodavac: rawParams.poslodavac ? rawParams.poslodavac : null ,
      kategorija: rawParams.kategorija ? rawParams.kategorija : null ,
      kljucna_rec: rawParams.kljucna_rec ? rawParams.kljucna_rec : null,
      tip_zaposlenja: rawParams.tip_zaposlenja ? rawParams.tip_zaposlenja : null,
      senioritet: rawParams.senioritet ? rawParams.senioritet : null,
      industrija: rawParams.industrija ? rawParams.industrija : null,
      jezik: rawParams.jezik ? rawParams.jezik : null,
      nivo_pozicije: rawParams.nivo_pozicije ? rawParams.nivo_pozicije : null,
      plata: rawParams.plata ? rawParams.plata : false,
      osobe_sa_invaliditetom: rawParams.osobe_sa_invaliditetom ? rawParams.osobe_sa_invaliditetom : false,
      poslovi_u_inostranstvu: rawParams.poslovi_u_inostranstvu ? rawParams.poslovi_u_inostranstvu : false,
      preko_50_godina: rawParams.preko_50_godina ? rawParams.preko_50_godina : false,
      rad_od_kuce: rawParams.rad_od_kuce ? rawParams.rad_od_kuce : false,
      za_studente: rawParams.za_studente ? rawParams.za_studente : false,
    }
  )

  const seoParams: any = useParams();

  const titleUrl =  params && params.title ? params.title : '';
  const employerUrl =  params && params.employer ? params.employer : '';
  const cityUrl =  params && params.city ? params.city : seoParams.city ? seoParams.city : seoParams.grad ? seoParams.grad : '';
  const fieldOfWorkUrl =  params && params.field_of_work ? params.field_of_work : seoParams.fieldOfWork ? seoParams.fieldOfWork : '';

  const dispatch = useDispatch();

  const refAsync = useRef<any>(null);
  const refTitleAsync = useRef<any>(null);
  const refCityAsync = useRef<any>(null);

  const optionsCities = useSelector(optionsCitiesSelector);
  const optionsCity = useSelector(optionsCitySelector);




  const loading = useSelector(loadingSelector);
  const optionsCompanies = useSelector(optionsCompaniesSelector);
  const optionsCompany = useSelector(optionsCompanySelector);
  const optionsPosition = useSelector(optionsPositionSelector);
  const optionsPositions = useSelector(optionsPositionsSelector);
  const selectCategoriesIndustry = useSelector(makeSelectCategoriesIndustry);
  const selectCategoriesAreaOfWork = useSelector(makeSelectCategoriesAreaOfWork);

  const [title, setTitle] = useState<Array<any>>([]);
  const [city, setCity] = useState<Array<any>>([]);
  const [fieldOfWork, setFieldOfWork] = useState<string>(fieldOfWorkUrl || '');
  const [jobDescription, setJobDescription] = useState<string>('');
  const [employmentType, setEmploymentType] = useState<string>('');
  const [seniority, setSeniority] = useState<string>('');
  const [positionLevel, setPositionLevel] = useState<string>('');
  const [employer, setEmployer] = useState<Array<any>>([]);
  const [industry, setIndustry] = useState<string>('');
  const [language, setLanguage] = useState<string>('');
  const [disability, setDisability] = useState<boolean>(false);
  const [forOver50, setForOver50] = useState<boolean>(false);
  const [jobsAbroad, setJobsAbroad] = useState<boolean>(false);
  const [forStudents, setForStudents] = useState<boolean>(false);
  const [remote, setRemote] = useState<boolean>(false);
  const [salary, setSalary] = useState<boolean>(false);
  const [open, setFilter] = useState(false);

  //cityUrl
  useEffect(()=> {
    if(cityUrl) {
      dispatch(getCityBySlug(cityUrl));
    }
  },[dispatch, cityUrl])

  useEffect(()=> {
    if(titleUrl) {
      dispatch(getPositionBySlug(titleUrl));
    }
  },[dispatch, titleUrl])

  useEffect(()=> {
    if(employerUrl) {
        dispatch(getCompanyBySlug(employerUrl));
    }
  },[dispatch, employerUrl])

  useEffect(()=> {
    if(fieldOfWorkUrl) {
      setFieldOfWork(fieldOfWorkUrl)
    }
  },[fieldOfWorkUrl])


  const getLabelFromValue = useCallback((optionsArray: Array<any>, optionsSelectedValue: string) => {
    const option = find(optionsArray, {
      'value': optionsSelectedValue
    });

    if(option) {
      return option.label;
    }
    return null;

  },[]);


  useEffect(() => {

      //setFieldOfWork(fieldOfWorkUrl || '');
      setJobDescription(params.job_description || '');
      setEmploymentType(params.employment_type || '');
      setSeniority(params.seniority || '');
      setPositionLevel(params.position_level || '');
      setIndustry(params.industry || '');
      setLanguage(params.language || '');
      setDisability(params.disability ? true : false);
      setForOver50(params.for_over_50 ? true : false);
      setJobsAbroad(params.jobs_abroad ? true : false);
      setForStudents(params.for_students ? true : false);
      setRemote(params.remote ? true : false);
      setSalary(params.salary ? true : false);

      if(params.title || params.employment_type || params.seniority || params.position_level || params.employer || params.language || params.disability || params.for_over_50 || params.jobs_abroad || params.for_students || params.remote || params.salary) {
        setFilter(true);
      }

  }, [fieldOfWorkUrl, params.disability, params.employer, params.employment_type, params.field_of_work, params.for_over_50, params.for_students, params.industry, params.job_description, params.jobs_abroad, params.language, params.position_level, params.remote, params.salary, params.seniority, params.title]);

  // Categories
  useEffect(() => {
    if(selectCategoriesAreaOfWork && !selectCategoriesAreaOfWork.length) {
      dispatch(selectCategoriesFilter());
    }

  }, [dispatch, selectCategoriesAreaOfWork]);

  useEffect(() => {
    if(optionsCity.length) {
      setCity(optionsCity)
    }
  }, [dispatch, optionsCity]);

  useEffect(() => {
    if(optionsPosition.length) {
      setTitle(optionsPosition)
    }
  }, [dispatch, optionsPosition]);

  useEffect(() => {
    if(optionsCompany.length) {
      setEmployer(optionsCompany)
    }
  }, [dispatch, optionsCompany]);


  const toggleFilter = () => {
    if(!open) {
      setTitle([]);
      setEmploymentType('');
      setSeniority('');
      setPositionLevel('');
      setEmployer([]);
      setIndustry('');
      setLanguage('');
      setDisability(false);
      setForOver50(false);
      setJobsAbroad(false);
      setForStudents(false);
      setRemote(false);
      setSalary(false);
    }

    setFilter(!open);
  };

  const getCities = useCallback((city) => {
    dispatch(getCitiesAction(city));
  }, [dispatch]);

  const getCompanies = useCallback((employer) => {
    dispatch(getCompaniesAction(employer));
  }, [dispatch]);

  const getPositions = useCallback((title) => {
    dispatch(getPositionsAction(title));
  }, [dispatch]);


  const clearCity = useCallback(() => {
    refCityAsync.current.clear();
    dispatch(clearCityAction());
    setCity([]);
  }, [dispatch]);

  const clearTitle = useCallback(() => {
    refTitleAsync.current.clear();
    dispatch(clearPositionAction());
    setTitle([]);
  }, [dispatch]);


  const clearEmployer = useCallback(() => {
    refAsync.current.clear();
    dispatch(clearCompanyAction());
    setEmployer([]);
  }, [dispatch]);

  const setFieldOfWorkWrapper = useCallback((value) => {
    setFieldOfWork(value);

  }, []);

  useEffect(()=> {
    if(clearFilters) {
      refAsync.current.clear()
      refTitleAsync.current.clear()
      refCityAsync.current.clear()
      dispatch(clearAll());
      setTitle([]);
      setCity([]);
      setEmployer([]);
    }
  },[dispatch, clearFilters])

  const onSubmit = useCallback((e)=>{

    e.preventDefault();

    const convertedSearch = converFromEngToSrb({
      title: title.length ? title[0].value : '',
      city: city.length ? city[0].value : '',
      field_of_work: fieldOfWork,
      seniority: seniority,
      position_level: positionLevel,
      employer: employer.length ? employer[0].value : '',
      job_description: jobDescription,
      employment_type: employmentType,
      salary: salary,
      industry: industry,
      language: language,
      disability: disability,
      for_students: forStudents,
      for_over_50: forOver50,
      jobs_abroad: jobsAbroad,
      remote: remote

    })

    const searchParams = encodeData(convertedSearch);

    history.push(routes.Jobs + '?' +  searchParams)
    if(typeof closeModal === 'function') {
      closeModal();

    }
    if(typeof searchResults === 'function') {
      let formatLanguage = getLabelFromValue(optionsLanguages, language);
      let formatIndustry = getLabelFromValue(selectCategoriesIndustry, industry);
      let formatFieldOfWork = getLabelFromValue(selectCategoriesAreaOfWork, fieldOfWork);


      let values = [
          title.length ? title[0].label : '',
          city.length ? city[0].label : '',
          fieldOfWork ? formatFieldOfWork : null,
          seniority,
          positionLevel,
          employer.length ? employer[0].label : '',
          jobDescription,
          employmentType,
          industry ? formatIndustry :  null,
          language ? formatLanguage :  null,
          disability ? intl.formatMessage(HomeMessages.JobDisability) : null,
          forStudents ? intl.formatMessage(HomeMessages.JobStudent) :  null,
          forOver50 ? intl.formatMessage(HomeMessages.JobAge) : null,
          salary ? intl.formatMessage(HomeMessages.JobSalary) : null,
          jobsAbroad ? intl.formatMessage(HomeMessages.JobAbroad) : null,
          remote ? intl.formatMessage(HomeMessages.Remote) : null
      ]

      let searchResultArray = values.filter(Boolean);
      setTimeout(window.scrollTo(0,0),100);

       searchResults(searchResultArray);
    }
  }, [title, city, fieldOfWork, seniority, positionLevel, employer, jobDescription, employmentType, salary, industry, language, disability, forStudents, forOver50, jobsAbroad, remote, closeModal, searchResults, getLabelFromValue, selectCategoriesIndustry, selectCategoriesAreaOfWork])

  return (
      <FiltersFormWrapper className="filters">

          <form onSubmit={onSubmit} >
            <H3><FormattedMessage {...HomeMessages.FiltersHeading} /></H3>
            <FormInput
              type="search"
              autoComplete={'off'}
              name='job_description'
              onKeyUp={(e:any) => e.keyCode === 13 ? onSubmit(e) : null}
              onInputChange={(value: string) => setJobDescription(value)}
              defaultValue={jobDescription}
              placeholder={intl.formatMessage(messages.SearchByKeyword)}
              resetButton={true}
            />
            <InputImg>
              <svg><use xlinkHref={`#location`} /></svg>
              {
                city.length ? <button className="cities-clear" type={'button'} onClick={clearCity} ><svg><use xlinkHref={`#close`} /></svg></button> : null
              }

                <AsyncTypeahead
                  id="city"
                  allowNew={false}
                  ref={refCityAsync}
                  isLoading={loading.cities}
                  minLength={2}
                  onBlur={()=> {
                    if(refCityAsync && !city) {
                      refCityAsync.current.clear()
                    }
                  }}
                  searchText={intl.formatMessage(messages.searching)}
                  emptyLabel={intl.formatMessage(messages.emptyLabel)}
                  selected={city.length ? city : []}
                  onChange={(selected: Array<SelectOption>) => setCity(selected)}
                  onSearch={getCities}
                  options={optionsCities}
                  placeholder={intl.formatMessage(generalMessages.City)}
                  renderMenuItemChildren={(option: SelectOption) => (
                    <span>{option.label}</span>
                  )}
                />

            </InputImg>

            <SelectReset
              options={selectCategoriesAreaOfWork}
              value={fieldOfWork}
              onKeyPress={onSubmit}
              onSelectChange={setFieldOfWorkWrapper}
              defaultOption={''}
              defaultOptionLabel={intl.formatMessage(messages.FieldOfWork)}
              defaultOptionDisabled={false}
              defaultOptionHidden={false}
              resetButton={true}
              icon={"work"}
              theme='white'
            />

            <OtherFilters>
              <span onClick={() => toggleFilter()}>
                { open ? <FormattedMessage {...HomeMessages.HideAdditionalFilters} /> : <FormattedMessage {...HomeMessages.AdditionalFilters} /> }
                <svg><use xlinkHref={`#filters`} /></svg>
              </span>
            </OtherFilters>

          <ExpandFilters className="filters__additional" open={open}>
            <AdditionalFilters className="additionalFilters">
              <InputImg>
                <svg className="isvg"><use xlinkHref={`#search-light`} /></svg>
                {
                  title.length ? <button className="cities-clear" type={'button'} onClick={clearTitle} ><svg className="isvg"><use xlinkHref={`#close`} /></svg></button> : null
                }
                <AsyncTypeahead
                  id="title"
                  allowNew={false}
                  isLoading={loading.positions}
                  minLength={2}
                  ref={refTitleAsync}
                  onBlur={()=> {
                    if(refTitleAsync && title.length === 0) {
                      refTitleAsync.current.clear()
                    }
                  }}

                  searchText={intl.formatMessage(messages.searching)}
                  emptyLabel={intl.formatMessage(messages.emptyLabel)}
                  onChange={(selected: Array<any>) => {setTitle(selected)}}
                  selected={title.length ? title : []}
                  onSearch={getPositions}
                  options={optionsPositions}
                  placeholder={intl.formatMessage(messages.Position)}
                  renderMenuItemChildren={(option: CityProps) => (
                    <span>{option.label}</span>
                  )}
                />
              </InputImg>
              <SelectReset
                options={optionsSeniority}
                value={seniority}
                onKeyPress={onSubmit}
                onSelectChange={setSeniority}
                defaultOption={''}
                defaultOptionLabel={intl.formatMessage(messages.Seniority)}
                defaultOptionDisabled={false}
                defaultOptionHidden={false}
                icon={'seniority'}
                resetButton={true}
                theme='white'
              />
              <SelectReset
                options={optionsLevel}
                value={positionLevel}
                onKeyPress={onSubmit}
                onSelectChange={setPositionLevel}
                defaultOption={''}
                defaultOptionLabel={intl.formatMessage(messages.PositionLevel)}
                defaultOptionDisabled={false}
                defaultOptionHidden={false}
                icon={'level'}
                resetButton={true}
                theme='white'
              />
              <SelectReset
                options={optionsContract}
                value={employmentType}
                onKeyPress={onSubmit}
                onSelectChange={setEmploymentType}
                defaultOption={''}
                defaultOptionLabel={intl.formatMessage(messages.EmploymentType)}
                defaultOptionDisabled={false}
                defaultOptionHidden={false}
                icon={'type'}
                resetButton={true}
                theme='white'
              />
              <InputImg>
                <svg className="isvg"><use xlinkHref={`#employer`} /></svg>
                {
                  employer.length ? <button className="cities-clear" type={'button'} onClick={clearEmployer} ><svg className="isvg"><use xlinkHref={`#close`} /></svg></button> : null
                }
                <AsyncTypeahead
                  id="employer"
                  allowNew ={false}
                  ref={refAsync}
                  isLoading={loading.companies}
                  onBlur={()=> {
                    if(refAsync && employer.length === 0) {
                      refAsync.current.clear()
                    }
                  }}
                  searchText={intl.formatMessage(messages.searching)}
                  emptyLabel={intl.formatMessage(messages.emptyLabel)}
                  minLength={2}
                  selected={employer.length ? employer : []}
                  onChange={(selected: Array<SelectOption>) => setEmployer(selected)}
                  onSearch={getCompanies}
                  options={optionsCompanies}
                  placeholder={intl.formatMessage(messages.Employer)}
                  renderMenuItemChildren={(option: SelectOption) => (
                    <span>{option.label}</span>
                  )}
                />
              </InputImg>
              <SelectReset
                options={selectCategoriesIndustry}
                value={industry}
                onSelectChange={setIndustry}
                onKeyPress={onSubmit}
                defaultOption={''}
                defaultOptionLabel={intl.formatMessage(messages.Industry)}
                defaultOptionDisabled={false}
                defaultOptionHidden={false}
                icon={'industry'}
                resetButton={true}
                theme='white'
              />
              {/* <SelectReset
                options={optionsLanguages}
                value={language}
                onSelectChange={setLanguage}
                defaultOption={''}
                onKeyPress={onSubmit}
                defaultOptionLabel={intl.formatMessage(messages.Language)}
                defaultOptionDisabled={false}
                defaultOptionHidden={false}
                icon={'language'}
                resetButton={true}
                theme='white'
              /> */}
              <CheckboxGroup>
                <CheckboxLg
                  text={intl.formatMessage(HomeMessages.JobDisability)}
                  isChecked={disability}
                  onCheckboxChange={setDisability}
                  theme='white'
                />
                <CheckboxLg
                  text={intl.formatMessage(HomeMessages.JobAge)}
                  isChecked={forOver50}
                  onCheckboxChange={setForOver50}
                  theme='white'
                />
                <CheckboxLg
                  text={intl.formatMessage(HomeMessages.JobStudent)}
                  isChecked={forStudents}
                  onCheckboxChange={setForStudents}
                  theme='white'
                />
                <CheckboxLg
                  text={intl.formatMessage(HomeMessages.JobAbroad)}
                  isChecked={jobsAbroad}
                  onCheckboxChange={setJobsAbroad}
                  theme='white'
                />
                <CheckboxLg
                  text={intl.formatMessage(HomeMessages.JobSalary)}
                  isChecked={salary}
                  onCheckboxChange={setSalary}
                  theme='white'
                />
                <CheckboxLg
                  text={intl.formatMessage(HomeMessages.Remote)}
                  isChecked={remote}
                  onCheckboxChange={setRemote}
                  theme='white'
                />
              </CheckboxGroup>
            </AdditionalFilters>
          </ExpandFilters>
          <ButtonSearch type="submit">
            <FormattedMessage {...HomeMessages.Searching} />
          </ButtonSearch>
          </form>
      </FiltersFormWrapper>

  )
}

const FiltersFormWrapper = styled.div`
  position: relative;
  background: ${colors.GRAY_EXTRA_LIGHT};
  padding: 54px 45px;

  @media (max-width: 769px) {
    padding: 30px 15px;
  }

  h3 {
    font-weight: 400;
    font-size: 14px;
    text-transform: uppercase;
    color: #9E9E9E;
    margin: 0 0 30px;
  }

  input, .rbt .rbt-input-main {
    background: ${colors.WHITE};
  }
`;

const OtherFilters = styled.div`
  margin: 28px 0 10px;

  @media (max-width: 769px) {
    display: none;
  }

  span {
    font-family: "Gilroy-Bold";
    color: ${colors.BLACK_COLOR};
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;

    @media (max-width: 769px) {
      margin-left: 5px;
    }

    svg {
      width: 18px;
      height: 18px;
      stroke: ${colors.PRIMARY_ORANGE};
      margin-left: 10px;
    }
  }
`;

const CheckboxGroup = styled.div`
  margin: 30px 0 0;
`;

const ButtonSearch = styled(Button)`
  width: 100%;
  margin-top: 18px;
`;

// ---------------------------------------------------------- Additional Filters
const AdditionalFilters = styled.div``;

const ExpandFilters = styled(Expand)`

  @media (max-width: 767px) {
    height: auto !important;
    opacity: 1 !important;
    overflow: unset !important;
  }
`;

export default memo(Filters);
